import { ReactElement } from "react";
import { formatNumber } from "src/utils/helper/functions";

type NumberProps = {
  number: number | string;
  subText?: string;
};

const Number: React.FC<NumberProps> = ({
  number,
  subText,
}: NumberProps): ReactElement => {
  return +number > 0 ? (
    <span className="text-green-500">
      {formatNumber(+number, 2)}
      {subText}
    </span>
  ) : (
    <span className="text-red-400 ">
      {formatNumber(-1 * +number?.toString()?.replace(",", ""), 2)}
      {subText}
    </span>
  );
};

export default Number;
